<template>
  <div>
    <b-loading :is-full-page="true" :active="!initialized"></b-loading>
    <section v-if="initialized" class="section is-main-section">
      <CardComponent>
        <div class="section has-text-centered">
          <h1 class="title">{{ added ? 'Create New Media' : 'Edit Media' }}</h1>
        </div>
        <div class="columns is-vcentered">
          <div class="column is-8 is-offset-2">
            <div class="flex-card light-bordered light-raised">
              <div class="card-body">
                <ValidationObserver ref="observer" v-slot="{ passes, errors }">
                  <form @submit.prevent="passes(submit)">
                    <div class="columns is-multiline">
                      <div class="column is-12">
                        <div class="control">
                          <ValidationProvider
                            v-slot="{ errors }"
                            name="Title"
                            rules="required"
                          >
                            <b-field
                              label="Title"
                              :type="{ 'is-danger': errors.length > 0 }"
                              :message="errors[0]"
                            >
                              <b-input v-model="item.title" />
                            </b-field>
                          </ValidationProvider>
                        </div>
                      </div>
                      <div class="column is-12">
                        <div class="control">
                          <ValidationProvider
                            v-slot="{ errors }"
                            name="Description"
                            rules="required"
                          >
                            <b-field
                              label="Description"
                              :type="{ 'is-danger': errors.length > 0 }"
                              :message="errors[0]"
                            >
                              <b-input
                                v-model="item.description"
                                type="textarea"
                              />
                            </b-field>
                          </ValidationProvider>
                        </div>
                      </div>
                      <div class="column is-12">
                        <div class="control">
                          <ValidationProvider
                            v-slot="{ errors }"
                            name="Tag line"
                          >
                            <b-field
                              label="Tag line"
                              :type="{ 'is-danger': errors.length > 0 }"
                              :message="errors[0]"
                            >
                              <b-input v-model="item.tagline" />
                            </b-field>
                          </ValidationProvider>
                        </div>
                      </div>
                      <div class="column is-6-desktop">
                        <div class="control">
                          <ValidationProvider
                            v-slot="{ errors }"
                            name="Media Type"
                            rules="required"
                          >
                            <b-field
                              label="Media Type"
                              :type="{ 'is-danger': errors.length > 0 }"
                              :message="errors[0]"
                            >
                              <b-select
                                v-model="item.mediaType"
                                placeholder="Select a type"
                                expanded
                                @input="addTopLevelGenre(item.mediaType)"
                              >
                                <option value=""></option>
                                <option value="movie">Movie</option>
                                <option value="series">Series</option>
                              </b-select>
                            </b-field>
                          </ValidationProvider>
                        </div>
                      </div>
                      <div class="column is-6-desktop">
                        <div class="control">
                          <ValidationProvider
                            v-slot="{ errors }"
                            name="Release Date"
                          >
                            <b-field label="Release Date">
                              <b-datepicker
                                v-model="item.releaseDate"
                                placeholder="Click to select..."
                                icon="calendar-today"
                              >
                              </b-datepicker>
                            </b-field>
                          </ValidationProvider>
                        </div>
                      </div>
                      <div class="column is-6-desktop">
                        <div class="control">
                          <ValidationProvider
                            v-slot="{ errors }"
                            name="Length in Minutes"
                            rules="required"
                          >
                            <b-field
                              :label="
                                (!item.mediaType || item.mediaType) === 'movie'
                                  ? 'Length in Minutes'
                                  : 'Standard Episode Length'
                              "
                            >
                              <b-input
                                v-model="item.mediaLength"
                                type="number"
                              />
                            </b-field>
                          </ValidationProvider>
                          <ValidationProvider
                            v-if="item.mediaType === 'series'"
                            v-slot="{ errors }"
                            name="Series No"
                          >
                            <b-field label="Series No">
                              <b-input v-model="item.seriesNo" type="number" />
                            </b-field>
                          </ValidationProvider>
                          <ValidationProvider
                            v-if="item.mediaType === 'series'"
                            v-slot="{ errors }"
                            name="No of Episodes"
                          >
                            <b-field label="No of Episodes">
                              <b-input
                                v-model="item.noOfEpisodes"
                                type="number"
                              />
                            </b-field>
                          </ValidationProvider>
                        </div>
                      </div>
                      <div class="column is-6-desktop">
                        <div class="control">
                          <ValidationProvider
                            v-slot="{ errors }"
                            name="Content Type"
                            rules="required"
                          >
                            <b-field
                              label="Content Type"
                              :type="{ 'is-danger': errors.length > 0 }"
                              :message="errors[0]"
                            >
                              <b-taginput
                                v-model="item.types"
                                icon="label"
                                placeholder="Select a top-level genre"
                                autocomplete
                                :data="filteredTypes"
                                field="value"
                                :open-on-focus="true"
                                @typing="getFilteredTypes"
                              >
                              </b-taginput>
                            </b-field>
                          </ValidationProvider>
                        </div>
                      </div>
                      <div class="column is-6-desktop">
                        <div class="control">
                          <ValidationProvider
                            v-slot="{ errors }"
                            rules="required"
                            name="Genre"
                          >
                            <b-field
                              label="Genre"
                              :type="{ 'is-danger': errors.length > 0 }"
                              :message="errors[0]"
                            >
                              <b-taginput
                                v-model="item.genres"
                                icon="label"
                                placeholder="Select a genre"
                                autocomplete
                                :data="filteredGenres"
                                field="value"
                                :open-on-focus="true"
                                @typing="getFilteredGenres"
                              >
                              </b-taginput>
                            </b-field>
                          </ValidationProvider>
                        </div>
                      </div>
                      <div class="column is-6-desktop">
                        <div class="control">
                          <ValidationProvider
                            v-slot="{ errors }"
                            name="Age Restriction"
                          >
                            <b-field
                              label="Age Restriction"
                              :type="{ 'is-danger': errors.length > 0 }"
                              :message="errors[0]"
                            >
                              <b-input v-model="item.ageRestriction" />
                            </b-field>
                          </ValidationProvider>
                        </div>
                      </div>
                      <div class="column is-6-desktop">
                        <div class="control">
                          <ValidationProvider v-slot="{ errors }" name="Cast">
                            <b-field
                              label="Cast"
                              :type="{ 'is-danger': errors.length > 0 }"
                              :message="errors[0]"
                            >
                              <b-taginput
                                v-model="item.actors"
                                icon="label"
                                placeholder="Select an cast member"
                                autocomplete
                                :data="filteredActors"
                                field="value"
                                :allow-new="true"
                                :open-on-focus="true"
                                @typing="getFilteredActors"
                                @add="addActor"
                              >
                              </b-taginput>
                            </b-field>
                          </ValidationProvider>
                        </div>
                      </div>
                      <div class="column is-6-desktop">
                        <div class="control">
                          <ValidationProvider
                            v-slot="{ errors }"
                            name="Directors"
                          >
                            <b-field
                              label="Directors"
                              :type="{ 'is-danger': errors.length > 0 }"
                              :message="errors[0]"
                            >
                              <b-taginput
                                v-model="item.directors"
                                icon="label"
                                placeholder="Select a director"
                                autocomplete
                                :data="filteredDirectors"
                                field="value"
                                :allow-new="true"
                                :open-on-focus="true"
                                @typing="getFilteredDirectors"
                                @add="addDirector"
                              >
                              </b-taginput>
                            </b-field>
                          </ValidationProvider>
                        </div>
                      </div>
                      <div class="column is-6-desktop">
                        <div class="control">
                          <ValidationProvider
                            v-slot="{ errors }"
                            name="Languages"
                          >
                            <b-field
                              label="Languages"
                              :type="{ 'is-danger': errors.length > 0 }"
                              :message="errors[0]"
                            >
                              <b-taginput
                                v-model="item.languages"
                                icon="label"
                                placeholder="Select a language"
                                autocomplete
                                :data="filteredLanguages"
                                field="value"
                                :allow-new="true"
                                :open-on-focus="true"
                                @typing="getFilteredLanguages"
                                @add="addLanguage"
                              >
                              </b-taginput>
                            </b-field>
                          </ValidationProvider>
                        </div>
                      </div>
                      <div class="column is-6-desktop">
                        <div class="control">
                          <ValidationProvider
                            v-slot="{ errors }"
                            name="Rights Owner"
                          >
                            <b-field
                              label="Rights Owner"
                              :type="{ 'is-danger': errors.length > 0 }"
                              :message="errors[0]"
                            >
                              <b-input v-model="item.rightsOwner" />
                            </b-field>
                          </ValidationProvider>
                        </div>
                      </div>
                      <div class="column is-6-desktop">
                        <div class="control">
                          <ValidationProvider
                            v-slot="{ errors }"
                            name="Distribution Rights"
                          >
                            <b-field
                              label="Distribution Rights"
                              :type="{ 'is-danger': errors.length > 0 }"
                              :message="errors[0]"
                            >
                              <b-taginput
                                v-model="item.rights"
                                icon="label"
                                placeholder="Select rights"
                                autocomplete
                                :data="filteredRights"
                                field="value"
                                :open-on-focus="true"
                                @typing="getFilteredRights"
                              >
                              </b-taginput>
                            </b-field>
                          </ValidationProvider>
                        </div>
                      </div>
                      <div class="column is-6-desktop">
                        <div class="control">
                          <ValidationProvider
                            v-slot="{ errors }"
                            name="Distribution Methods"
                          >
                            <b-field
                              label="Distribution Methods"
                              :type="{ 'is-danger': errors.length > 0 }"
                              :message="errors[0]"
                            >
                              <div class="columns">
                                <div class="column is-10">
                                  <b-taginput
                                    v-model="item.distributions"
                                    icon="label"
                                    placeholder="Select distribution methods"
                                    autocomplete
                                    :data="filteredDistributions"
                                    field="value"
                                    :open-on-focus="true"
                                    @typing="getFilteredDistributions"
                                  >
                                  </b-taginput>
                                </div>
                                <div class="column is-2">
                                  <b-button
                                    type="is-primary"
                                    @click="addAllDistributions"
                                    >All</b-button
                                  >
                                </div>
                              </div>
                            </b-field>
                          </ValidationProvider>
                        </div>
                      </div>
                      <div class="column is-6-desktop">
                        <div class="control">
                          <ValidationProvider
                            v-slot="{ errors }"
                            name="Rights Countries"
                          >
                            <b-field
                              label="Rights Countries"
                              :type="{ 'is-danger': errors.length > 0 }"
                              :message="errors[0]"
                            >
                              <b-taginput
                                v-model="item.countries"
                                icon="label"
                                placeholder="Select a country"
                                autocomplete
                                :data="filteredCountries"
                                field="value"
                                :open-on-focus="true"
                                @typing="getFilteredCountries"
                              >
                              </b-taginput>
                            </b-field>
                          </ValidationProvider>
                        </div>
                      </div>
                      <div class="column is-6-desktop">
                        <div class="control">
                          <ValidationProvider
                            v-slot="{ errors }"
                            name="Rights Excluded Countries"
                          >
                            <b-field
                              label="Rights Excluded Countries"
                              :type="{ 'is-danger': errors.length > 0 }"
                              :message="errors[0]"
                            >
                              <b-taginput
                                v-model="item.excludedcountries"
                                icon="label"
                                placeholder="Select a country"
                                autocomplete
                                :data="filteredExcludedCountries"
                                field="value"
                                :open-on-focus="true"
                                @typing="getFilteredExcludedCountries"
                              >
                              </b-taginput>
                            </b-field>
                          </ValidationProvider>
                        </div>
                      </div>
                      <div class="column is-6-desktop">
                        <div class="control">
                          <ValidationProvider
                            v-slot="{ errors }"
                            name="Supplier"
                            rules="required"
                          >
                            <b-field
                              label="Supplier"
                              :type="{ 'is-danger': errors.length > 0 }"
                              :message="errors[0]"
                            >
                              <b-taginput
                                v-model="item.suppliers"
                                :maxtags="1"
                                icon="label"
                                placeholder="Select a supplier"
                                autocomplete
                                :data="filteredSuppliers"
                                field="value"
                                :open-on-focus="true"
                                :allow-new="true"
                                @typing="getFilteredSuppliers"
                              >
                              </b-taginput>
                            </b-field>
                          </ValidationProvider>
                        </div>
                      </div>
                      <div class="column is-6-desktop">
                        <div class="control">
                          <ValidationProvider
                            v-slot="{ errors }"
                            name="Channels"
                          >
                            <b-field
                              label="Channels"
                              :type="{ 'is-danger': errors.length > 0 }"
                              :message="errors[0]"
                            >
                              <b-taginput
                                v-model="item.channels"
                                icon="label"
                                placeholder="Select a channel"
                                autocomplete
                                :data="filteredChannels"
                                field="name"
                                :open-on-focus="true"
                                @typing="getFilteredChannels"
                              >
                              </b-taginput>
                            </b-field>
                          </ValidationProvider>
                        </div>
                      </div>
                      <div class="column is-6-desktop">
                        <div class="control">
                          <ValidationProvider v-slot="{ errors }" name="Audio">
                            <b-field
                              label="Audio"
                              :type="{ 'is-danger': errors.length > 0 }"
                              :message="errors[0]"
                            >
                              <b-taginput
                                v-model="item.audios"
                                icon="label"
                                placeholder="Select an audio option"
                                autocomplete
                                :data="filteredAudios"
                                field="value"
                                :open-on-focus="true"
                                @typing="getFilteredAudios"
                              >
                              </b-taginput>
                            </b-field>
                          </ValidationProvider>
                        </div>
                      </div>
                      <div class="column is-6-desktop">
                        <div class="control">
                          <ValidationProvider
                            v-slot="{ errors }"
                            name="Resolutions"
                          >
                            <b-field
                              label="Resolutions"
                              :type="{ 'is-danger': errors.length > 0 }"
                              :message="errors[0]"
                            >
                              <b-taginput
                                v-model="item.resolutions"
                                icon="label"
                                placeholder="Select a resolution"
                                autocomplete
                                :data="filteredResolutions"
                                field="value"
                                :open-on-focus="true"
                                @typing="getFilteredResolutions"
                              >
                              </b-taginput>
                            </b-field>
                          </ValidationProvider>
                        </div>
                      </div>
                      <div class="column is-6-desktop">
                        <div class="control">
                          <ValidationProvider v-slot="{ errors }" name="Tags">
                            <b-field
                              label="Tags"
                              :type="{ 'is-danger': errors.length > 0 }"
                              :message="errors[0]"
                            >
                              <b-taginput
                                v-model="item.tags"
                                icon="label"
                                placeholder="Select tags"
                                autocomplete
                                :data="filteredTags"
                                field="value"
                                :allow-new="true"
                                :open-on-focus="true"
                                @typing="getFilteredTags"
                                @add="addTag"
                              >
                              </b-taginput>
                            </b-field>
                          </ValidationProvider>
                        </div>
                      </div>
                      <div class="column is-6-desktop">
                        <div class="control">
                          <ValidationProvider
                            v-slot="{ errors }"
                            name="Hashtags"
                          >
                            <b-field
                              label="Hashtags"
                              :type="{ 'is-danger': errors.length > 0 }"
                              :message="errors[0]"
                            >
                              <b-taginput
                                v-model="item.hashtags"
                                icon="label"
                                placeholder="Select hashtags"
                                autocomplete
                                :data="filteredHashtags"
                                field="value"
                                :allow-new="true"
                                :open-on-focus="true"
                                @typing="getFilteredHashtags"
                                @add="addHashtag"
                              >
                              </b-taginput>
                            </b-field>
                          </ValidationProvider>
                        </div>
                      </div>
                      <div class="column is-6-desktop"></div>
                      <div class="column is-6-desktop">
                        <div class="control">
                          <UploadImage
                            v-model="item.titleImage"
                            label="Title Image"
                          ></UploadImage>
                        </div>
                      </div>
                      <div class="column is-6-desktop">
                        <div class="control">
                          <UploadImage
                            v-model="item.featuredImage"
                            label="Featured Image"
                          ></UploadImage>
                        </div>
                      </div>
                      <div class="column is-6-desktop">
                        <div class="control">
                          <UploadImage
                            v-model="item.bannerImage"
                            label="Banner Image"
                          ></UploadImage>
                        </div>
                      </div>
                      <div class="column is-6-desktop"></div>
                      <div class="column is-6-desktop">
                        <div class="control">
                          <UploadVideo
                            v-model="item.trailerVideo"
                            label="Trailer Video"
                          ></UploadVideo>
                        </div>
                      </div>
                      <div class="column is-6-desktop">
                        <div class="control">
                          <UploadVideo
                            v-model="item.screenerVideo"
                            label="Screener Video"
                          ></UploadVideo>
                        </div>
                      </div>
                      <div v-if="!added" class="column is-6-desktop">
                        <div class="control">
                          <UploadMediaAssets
                            :media-id="item.id"
                          ></UploadMediaAssets>
                        </div>
                      </div>
                    </div>
                    <div class="has-text-centered">
                      <div class="is-block has-margin-bottom-15">
                        <b-button
                          icon-left="arrow-left"
                          class="is-medium has-margin-right-10"
                          tag="router-link"
                          :to="{
                            name:
                              $route.query && $route.query.admin
                                ? 'ManageAllMedia'
                                : 'ManageMedia'
                          }"
                        >
                          Back to List</b-button
                        >
                        <b-button
                          v-if="item.mediaType === 'series'"
                          class="is-medium has-margin-right-10"
                          tag="router-link"
                          :to="{
                            name: 'ManageEpisodes',
                            params: { id: item.id }
                          }"
                        >
                          Manage Episodes</b-button
                        >
                        <button
                          class="button is-primary is-medium btn-align no-lh raised primary-btn"
                          type="submit"
                          :disabled="loading"
                          :class="{ 'is-loading': loading }"
                        >
                          {{ added ? 'Create' : 'Update' }}
                        </button>
                      </div>
                    </div>
                  </form>
                </ValidationObserver>
              </div>
            </div>
          </div>
        </div>
      </CardComponent>
    </section>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import CardComponent from '@/components/CardComponent'
import UploadMediaAssets from '@/components/UploadMediaAssets'
import UploadImage from '@/components/UploadImage'
import UploadVideo from '@/components/UploadVideo'
import MediaApi from '@/api/media'
import ChannelApi from '@/api/channels'
import MediaChannelApi from '@/api/mediaChannels'

export default {
  name: 'EditMedia',
  components: {
    CardComponent,
    UploadImage,
    UploadVideo,
    UploadMediaAssets
  },
  metaInfo: {
    title: 'Edit Title'
  },
  computed: {
    ...mapGetters(['user'])
  },
  async mounted() {
    this.added = this.$route.name === 'CreateMedia' ? true : false
    if (!this.added) {
      this.setData()
      this.initialized = false
    }
    this.links = await MediaApi.getMetadataLinks()
    const lookups = await MediaApi.defaultLookups()
    this.genres = lookups.genre ? lookups.genre : []
    this.getFilteredGenres('')
    this.languages = lookups.language ? lookups.language : []
    this.filteredLanguages = this.languages
    this.countries = lookups.country ? lookups.country : []
    this.filteredCountries = this.countries
    this.excludedcountries = lookups.excludedcountry
      ? lookups.excludedcountry
      : []
    this.filteredExcludedCountries = this.excludedcountries
    this.tags = lookups.tag ? lookups.tag : []
    this.hashtags = lookups.hashtags ? lookups.hashtags : []
    this.filteredTags = this.tags
    this.filteredHashtags = this.hashtags
    this.actors = lookups.actor ? lookups.actor : []
    this.filteredActors = this.actors
    this.directors = lookups.director ? lookups.director : []
    this.filteredDirectors = this.directors
    this.suppliers = lookups.supplier ? lookups.supplier : []
    this.filteredSuppliers = this.suppliers
    this.resolutions = lookups.resolution ? lookups.resolution : []
    this.filteredResolutions = this.resolutions
    this.audios = lookups.audio ? lookups.audio : []
    this.filteredAudios = this.audios
    this.types = lookups.type ? lookups.type : []
    this.filteredTypes = this.types
    this.rights = lookups.right ? lookups.right : []
    this.filteredRights = this.rights
    this.distributions = lookups.distribution ? lookups.distribution : []
    this.getFilteredDistributions('')
    this.channels = await ChannelApi.getAll()
    this.getFilteredChannels('')
    this.initialized = true
  },
  data() {
    return {
      loading: false,
      initialized: false,
      added: false,
      item: {
        titleImage: null,
        featuredImage: null,
        bannerImage: null,
        trailerVideo: null,
        screenerVideo: null
      },
      genres: [],
      countries: [],
      languages: [],
      tags: [],
      hashtags: [],
      actors: [],
      directors: [],
      resolutions: [],
      audio: [],
      suppliers: [],
      types: [],
      rights: [],
      channels: [],
      distributions: [],
      filteredGenres: [],
      filteredLanguages: [],
      filteredCountries: [],
      filteredExcludedCountries: [],
      filteredTags: [],
      filteredHashtags: [],
      filteredActors: [],
      filteredTypes: [],
      filteredRights: [],
      filteredDistributions: [],
      filteredChannels: [],
      filteredDirectors: [],
      filteredResolutions: [],
      filteredAudios: [],
      filteredSuppliers: [],
      links: []
    }
  },
  methods: {
    ...mapActions(['getUser']),
    async setData() {
      this.initialized = false
      this.added = false
      let media = await MediaApi.getById(this.$route.params.id)
      if (media) {
        this.item.id = media.id
        this.item.title = media.title
        this.item.description = media.description
        this.item.mediaType = media.media_type
        this.item.published = media.published
        if (media.mediadata && media.mediadata !== '') {
          media.mediadata = JSON.parse(media.mediadata)
          if (media.mediadata.releaseDate) {
            this.item.releaseDate = new Date(media.mediadata.releaseDate)
          }
          this.item.mediaLength = media.mediadata.mediaLength
          this.item.tagline = media.mediadata.tagline

          if (this.item.mediaType === 'series') {
            this.item.noOfEpisodes = media.mediadata.noOfEpisodes
            this.item.seriesNo = media.mediadata.seriesNo
          }

          this.item.titleImage = media.mediadata.titleImage
          this.item.featuredImage = media.mediadata.featuredImage
          this.item.bannerImage = media.mediadata.bannerImage
          this.item.trailerVideo = media.mediadata.trailerVideo
          this.item.screenerVideo = media.mediadata.screenerVideo
          this.item.ageRestriction = media.mediadata.ageRestriction
          this.item.rightsOwner = media.mediadata.rightsOwner
        }
        if (media.mediaMetadata && media.mediaMetadata.length > 0) {
          this.item.genres = this.setValues(media.mediaMetadata, 'genre')
          this.item.countries = this.setValues(media.mediaMetadata, 'country')
          this.item.excludedcountries = this.setValues(
            media.mediaMetadata,
            'excludedcountry'
          )
          this.item.languages = this.setValues(media.mediaMetadata, 'language')
          this.item.tags = this.setValues(media.mediaMetadata, 'tag')
          this.item.hashtags = this.setValues(media.mediaMetadata, 'hashtag')
          this.item.actors = this.setValues(media.mediaMetadata, 'actor')
          this.item.directors = this.setValues(media.mediaMetadata, 'director')
          this.item.suppliers = this.setValues(media.mediaMetadata, 'supplier')
          this.item.audios = this.setValues(media.mediaMetadata, 'audio')
          this.item.resolutions = this.setValues(
            media.mediaMetadata,
            'resolution'
          )
          this.item.types = this.setValues(media.mediaMetadata, 'type')
          this.item.rights = this.setValues(media.mediaMetadata, 'right')
          this.item.distributions = this.setValues(
            media.mediaMetadata,
            'distribution'
          )
          this.item.channels = await MediaChannelApi.getByMediaId(media.id)
        }
      }
      this.initialized = true
    },
    getValues(list) {
      return list ? list.map(item => (item.value ? item.value : item)) : []
    },
    setValues(list, type) {
      return list
        ? list
            .filter(item => item.metadata_type === type)
            .map(item => ({
              id: item.metadata_id,
              value: item.value,
              metadata_type: type
            }))
        : []
    },
    submit() {
      this.item.mediadata = {
        titleImage: this.item.titleImage,
        featuredImage: this.item.featuredImage,
        bannerImage: this.item.bannerImage,
        trailerVideo: this.item.trailerVideo,
        screenerVideo: this.item.screenerVideo,
        mediaLength: this.item.mediaLength,
        tagline: this.item.tagline,
        noOfEpisodes: this.item.noOfEpisodes,
        seriesNo: this.item.seriesNo,
        releaseDate: this.item.releaseDate,
        ageRestriction: this.item.ageRestriction,
        rightsOwner: this.item.rightsOwner
      }
      this.item.metadata = {
        genres: this.getValues(this.item.genres),
        languages: this.getValues(this.item.languages),
        countries: this.getValues(this.item.countries),
        excludedcountries: this.getValues(this.item.excludedcountries),
        tags: this.getValues(this.item.tags),
        hashtags: this.getValues(this.item.hashtags),
        actors: this.getValues(this.item.actors),
        types: this.getValues(this.item.types),
        rights: this.getValues(this.item.rights),
        distributions: this.getValues(this.item.distributions),
        directors: this.getValues(this.item.directors),
        suppliers: this.getValues(this.item.suppliers),
        resolutions: this.getValues(this.item.resolutions),
        audios: this.getValues(this.item.audios),
        channels: this.getValues(this.item.channels)
      }
      this.loading = true
      if (!this.item.id) {
        MediaApi.create(this.item)
          .then(response => {
            this.$buefy.toast.open({
              message: 'Media created successfully!',
              position: 'is-top',
              type: 'is-success'
            })
            this.$router.push({
              name: 'EditMedia',
              params: { id: response.mediaId }
            })
            this.setData()
            this.loading = false
          })
          .catch(err => {
            console.log(err)
            this.$buefy.toast.open({
              message: 'Error saving media',
              position: 'is-top',
              type: 'is-danger'
            })
            this.loading = false
          })
      } else {
        this.item.mediaId = this.item.id
        MediaApi.update(this.item)
          .then(() => {
            this.$buefy.toast.open({
              message: 'Media updated successfully!',
              position: 'is-top',
              type: 'is-success'
            })
            this.setData()
            this.loading = false
          })
          .catch(err => {
            console.log(err)
            this.$buefy.toast.open({
              message: 'Error saving media',
              position: 'is-top',
              type: 'is-danger'
            })
            this.loading = false
          })
      }
    },
    getFilteredChannels(text) {
      this.filteredChannels = this.channels.filter(option => {
        return option.name.toLowerCase().indexOf(text.toLowerCase()) >= 0
      })
    },
    getFilteredMetadata(text, key, filteredKey) {
      this[filteredKey] = this[key].filter(option => {
        return option.value.toLowerCase().indexOf(text.toLowerCase()) >= 0
      })
    },
    getFilteredGenres(text) {
      if (this.item.types && this.item.types.length > 0) {
        const topLevelGenreIds = this.item.types.map(item => item.id)
        const childIds = this.links
          .filter(item => topLevelGenreIds.includes(item.metadata_id))
          .map(item => item.linked_metadata_id)
        this.filteredGenres = this.genres.filter(option => {
          return (
            childIds.includes(option.id) &&
            option.value.toLowerCase().indexOf(text.toLowerCase()) >= 0
          )
        })
      }
      return []
    },
    getFilteredLanguages(text) {
      this.getFilteredMetadata(text, 'languages', 'filteredLanguages')
    },
    getFilteredCountries(text) {
      this.getFilteredMetadata(text, 'countries', 'filteredCountries')
    },
    getFilteredExcludedCountries(text) {
      this.getFilteredMetadata(
        text,
        'excludedcountries',
        'filteredExcludedCountries'
      )
    },
    getFilteredTags(text) {
      this.getFilteredMetadata(text, 'tags', 'filteredTags')
    },
    getFilteredHashtags(text) {
      this.getFilteredMetadata(text, 'hashtags', 'filteredHashtags')
    },
    getFilteredActors(text) {
      this.getFilteredMetadata(text, 'actors', 'filteredActors')
    },
    getFilteredDirectors(text) {
      this.getFilteredMetadata(text, 'directors', 'filteredDirectors')
    },
    getFilteredSuppliers(text) {
      this.getFilteredMetadata(text, 'suppliers', 'filteredSuppliers')
    },
    getFilteredResolutions(text) {
      this.getFilteredMetadata(text, 'resolutions', 'filteredResolutions')
    },
    getFilteredAudios(text) {
      this.getFilteredMetadata(text, 'audios', 'filteredAudios')
    },
    getFilteredTypes(text) {
      this.getFilteredMetadata(text, 'types', 'filteredTypes')
    },
    getFilteredRights(text) {
      this.getFilteredMetadata(text, 'rights', 'filteredRights')
    },
    getFilteredDistributions(text) {
      if (this.item.rights && this.item.rights.length > 0) {
        const topLevelRightIds = this.item.rights.map(item => item.id)
        const childIds = this.links
          .filter(item => topLevelRightIds.includes(item.metadata_id))
          .map(item => item.linked_metadata_id)
        this.filteredDistributions = this.distributions.filter(option => {
          return (
            childIds.includes(option.id) &&
            option.value.toLowerCase().indexOf(text.toLowerCase()) >= 0
          )
        })
      }
      return []

      // this.getFilteredMetadata(text, 'distributions', 'filteredDistributions')
    },
    addItem(key, text) {
      if (typeof text === 'string') {
        let existing = this[key].find(
          item => item.value && item.value.toLowerCase() === text.toLowerCase()
        )
        if (existing) {
          this.item[key] = this.item[key].filter(item => item !== text)
        }
      }
    },
    addGenre(text) {
      this.addItem('genres', text)
    },
    addLanguage(text) {
      this.addItem('languages', text)
    },
    addCountry(text) {
      this.addItem('countries', text)
    },
    addTag(text) {
      this.addItem('tags', text)
    },
    addHashtag(text) {
      this.addItem('hashtags', text)
    },
    addActor(text) {
      this.addItem('actors', text)
    },
    addDirector(text) {
      this.addItem('directors', text)
    },
    addSupplier(text) {
      this.addItem('suppliers', text)
    },
    addResolutions(text) {
      this.addItem('resolutions', text)
    },
    addAudios(text) {
      this.addItem('audios', text)
    },
    addType(text) {
      this.addItem('types', text)
    },
    addRight(text) {
      this.addItem('rights', text)
    },
    addDistribution(text) {
      this.addItem('distributions', text)
    },
    addTopLevelGenre(mediatype) {
      let found = null
      const removeItem = mediatype === 'series' ? 'movie' : 'series'
      this.item.types = this.item.types.filter(
        item => item.value.toLowerCase() !== removeItem
      )
      found = this.types.find(item => item.value.toLowerCase() === mediatype)
      if (found) {
        this.item.types.push(found)
      }
    },
    addAllDistributions() {
      const topLevelRightIds = this.item.rights.map(item => item.id)
      const childIds = this.links
        .filter(item => topLevelRightIds.includes(item.metadata_id))
        .map(item => item.linked_metadata_id)
      let distributions = this.distributions.filter(option => {
        return childIds.includes(option.id)
      })
      distributions.forEach(distribution => {
        if (this.item.distributions) {
          let found = this.item.distributions.find(
            item => item.id === distribution.id
          )
          if (!found) {
            this.item.distributions.push(distribution)
          }
        }
      })
    }
  }
}
</script>
